// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"aa303305","89":"1b539531","421":"76df1c7f"}[chunkId] + ".chunk.js";
};